import React, { useState, useEffect } from 'react';

const ProductForm = ({ onAddProduct, onSaveEdit, onCancelEdit, editingProduct }) => {
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    category: 'software',
    description: '',
    status: 'active',
    launchDate: new Date().toISOString().split('T')[0]
  });
  
  // Quando estiver editando um produto, preencher o formulário com os dados dele
  useEffect(() => {
    if (editingProduct) {
      setFormData({
        name: editingProduct.name || '',
        price: editingProduct.price || '',
        category: editingProduct.category || 'software',
        description: editingProduct.description || '',
        status: editingProduct.status || 'active',
        launchDate: editingProduct.launchDate || new Date().toISOString().split('T')[0]
      });
    } else {
      // Resetar formulário quando não estiver editando
      setFormData({
        name: '',
        price: '',
        category: 'software',
        description: '',
        status: 'active',
        launchDate: new Date().toISOString().split('T')[0]
      });
    }
  }, [editingProduct]);
  
  // Lidar com mudanças nos campos do formulário
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  // Enviar formulário
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validação básica
    if (!formData.name || !formData.price) {
      alert('Por favor, preencha pelo menos o nome e o preço do produto!');
      return;
    }
    
    // Formatar os dados para garantir que sejam do tipo correto
    const formattedData = {
      ...formData,
      price: parseFloat(formData.price) || 0
    };
    
    // Se estiver editando, salvar edição, senão adicionar novo produto
    if (editingProduct) {
      onSaveEdit(formattedData);
    } else {
      onAddProduct(formattedData);
    }
    
    // Limpar formulário
    setFormData({
      name: '',
      price: '',
      category: 'software',
      description: '',
      status: 'active',
      launchDate: new Date().toISOString().split('T')[0]
    });
  };
  
  return (
    <form className="product-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="name">Nome do Produto</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Nome do produto"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="price">Preço (R$)</label>
          <input
            type="number"
            id="price"
            name="price"
            value={formData.price}
            onChange={handleChange}
            placeholder="0.00"
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>
      
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="category">Categoria</label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="software">Software</option>
            <option value="curso">Curso</option>
            <option value="consultoria">Consultoria</option>
            <option value="servico">Serviço</option>
            <option value="outro">Outro</option>
          </select>
        </div>
        
        <div className="form-group">
          <label htmlFor="status">Status</label>
          <select
            id="status"
            name="status"
            value={formData.status}
            onChange={handleChange}
            required
          >
            <option value="active">Ativo</option>
            <option value="inactive">Inativo</option>
            <option value="development">Em Desenvolvimento</option>
            <option value="discontinued">Descontinuado</option>
          </select>
        </div>
      </div>
      
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="launchDate">Data de Lançamento</label>
          <input
            type="date"
            id="launchDate"
            name="launchDate"
            value={formData.launchDate}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      
      <div className="form-row">
        <div className="form-group full-width">
          <label htmlFor="description">Descrição</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Descrição do produto"
            rows="3"
          ></textarea>
        </div>
      </div>
      
      <div className="form-actions">
        {editingProduct ? (
          <>
            <button type="submit" className="btn-primary">Salvar Alterações</button>
            <button type="button" className="btn-secondary" onClick={onCancelEdit}>Cancelar</button>
          </>
        ) : (
          <button type="submit" className="btn-primary">Adicionar Produto</button>
        )}
      </div>
    </form>
  );
};

export default ProductForm;